<template>
  <transition
    name="fade"
    mode="out-in"
    appear
  >
    <router-link
      :id="residence.slug"
      :to="route"
      :class="css"
      @mouseover.native.stop="toggleFocus(true)"
      @mouseout.native.stop="toggleFocus(false)"
      @focus.native.stop="toggleFocus(true)"
      @focusout.native.stop="toggleFocus(false)"
      class="c-residence"
      tabindex="0"
    >
      <card-image
        v-if="listType === 'cards' && residence.images.length > 0 && residence.hasImages === true"
        :id="residence.id"
      />
      <spinner
        v-if="listType === 'cards' && residence.images.length === 0 && residence.hasImages === true"
        class="c-spinner c-spinner--card"
      />
      <MissingImage
        v-if="listType === 'cards' && residence.images.length === 0 && residence.hasImages === false"
      />
      <header class="c-residence__header">
        <h2 class="c-residence__name">
          {{ residence.name }}
        </h2>
        <p class="c-residence__price">
          {{ priceInfo }}
        </p>
      </header>
      <ul
        v-if="type || bedrooms || size"
        class="c-residence__facts"
      >
        <li
          v-if="type"
          class="c-residence__fact"
        >
          {{ type }}
        </li>
        <li
          v-if="bedrooms"
          class="c-residence__fact"
        >
          {{ bedrooms }}
        </li>
        <li
          v-if="size"
          class="c-residence__fact"
        >
          {{ size }}
        </li>
      </ul>
    </router-link>
  </transition>
</template>

<script>
import { EventBus, } from '@/event-bus.js';

// VUEX Models
import Residence from '@/models/Residence';
import Sectionable from '@/models/Sectionable';

// UI Components
import CardImage from '@/components/CardImage.vue';
import Spinner from '@/components/Spinner.vue';
import MissingImage from '@/components/MissingImage.vue';

export default {
  name: 'ResidenceItem',
  components: {
    CardImage,
    Spinner,
    MissingImage,
  },
  props: {
    showImg: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  data: function() {
    return {
      hasFocus: false,
    };
  },
  computed: {
    residence() {
      return Residence.query()
        .with('availability')
        .with('residenceType')
        .with('bedrooms')
        .with('images')
        .with('shapes')
        .find(this.id);
    },
    sectionable() {
      return Sectionable.query()
        .where('sectionable_id', this.id)
        .first();
    },
    section_id() {
      if (this.sectionable) {
        return this.sectionable.section_id;
      } else {
        return false;
      }
    },
    route() {
      return `bolig/${this.residence.slug}`;
    },
    priceInfo() {
      if(this.residence.availability.slug === 'for-sale') {
        return `${this.residence.totalPrice().toLocaleString('nb-NO')},–`;
      } else if (this.residence.availability.showPrice === true) {
        return `${this.residence.availability.name}: ${this.residence.totalPrice().toLocaleString('nb-NO')},–`;
      } else {
        return this.residence.availability.name;
      }
    },
    type() {
      if (this.residence.residenceType) {
        return this.residence.residenceType.name;
      } else {
        return false;
      }
    },
    bedrooms() {
      if (this.residence.bedrooms) {
        return `Soverom: ${this.residence.bedrooms.name}`;
      } else {
        return false;
      }
    },
    illustrationIds() {
      let ids = [];
      this.residence.shapes.forEach(shape => {
        ids.push(shape.illustration);
      });
      return ids;
    },
    size() {
      if (this.residence.size) {
        return `BRA: ${this.residence.size}\xa0m²`;
      } else {
        return false;
      }
    },
    listType() {
      return this.$store.state.entities.residences.listType;
    },
    css() {
      const availability = this.residence.availability;
      let classes = '';
      if (availability) {
        classes += 'is-' + availability.slug;
      } else {
        classes += 'is-none';
      }
      if (this.hasFocus === true) {
        classes += ' has-focus';
      }
      if (this.listType === 'cards') {
        classes += ' c-residence--card';
      }
      return classes; 
    },
  },
  created() {
    EventBus.$on('residence-focus', residenceFocus => {
      if (residenceFocus.id === this.residence.id) {
        this.hasFocus = residenceFocus.hasFocus;
      }
    });
  },
  methods: {
    toggleFocus(focus) {
      EventBus.$emit('residence-focus', {
        hasFocus: focus,
        id: this.id,
        illustrationIds: this.illustrationIds,
      });
      if (this.section_id) {
        EventBus.$emit('section-focus', {
          hasFocus: focus,
          id: this.section_id,
        });
      }
    },
  },
};
</script>
